import type { Messages } from '../catalogue.en'

/**
 * Laboratory recognition of a file: the Files row's words for where it stands,
 * the replacement question, the progress and page-choice stops, cancellation
 * and why a recognition stopped.
 */
export const laboratoryRecognition: Partial<Messages> = {
  'lab.recognition.notLaboratoryFile': 'הקובץ אינו מסווג כתוצאות מעבדה.',
  'lab.recognition.batchRecognize': 'זיהוי הקבצים שנבחרו ({count})',
  'lab.recognition.workspaceTitle': 'זיהוי תוצאות מעבדה',
  'lab.recognition.backToFiles': 'חזרה לקובצי המעבדה',
  'lab.recognition.batchSummary': 'קבצים: {files} · עמודים: {pages} · נבחרו: {selected}',
  'lab.recognition.batchFiles': 'קבצים בזיהוי זה',
  'lab.recognition.recognizeBatch': 'זיהוי העמודים שנבחרו',
  'lab.recognition.pagesPanel': 'עמודי המסמכים',
  'lab.recognition.showPages': 'הצגת החלונית',
  'lab.recognition.hidePages': 'הסתרת החלונית',
  'lab.recognition.showPage': 'הצגת עמוד {number} בקובץ {name}',
  'lab.recognition.includePage': 'כלילת עמוד {number} בזיהוי',
  'lab.recognition.rowRecognize': 'זיהוי',
  'lab.recognition.notStarted': 'הזיהוי טרם התחיל.',
  'lab.recognition.rowRecognizeNamed': 'זיהוי תוצאות מעבדה בקובץ {name}',
  'lab.recognition.rowReading': 'קריאת עמודים…',
  'lab.recognition.rowReadingNamed': 'קריאת העמודים של {name}',
  'lab.recognition.rowChoosePages': 'בחירת עמודים',
  'lab.recognition.rowChoosePagesNamed': 'בחירת העמודים של {name} לזיהוי',
  'lab.recognition.rowRecognizing': 'בזיהוי: {done} מתוך {total}',
  'lab.recognition.rowRecognizingNamed': 'זיהוי {name}: הושלמו {done} מתוך {total} עמודים',
  'lab.recognition.rowReview': 'בדיקת הטיוטה',
  'lab.recognition.rowReviewNamed': 'בדיקת התוצאות שזוהו בקובץ {name}',
  'lab.recognition.rowFailed': 'הזיהוי נעצר',
  'lab.recognition.rowFailedNamed': 'הזיהוי של {name} נעצר: לפתיחה',
  'lab.recognition.rowConfirmed': 'אושר {date}',
  'lab.recognition.rowConfirmedNamed': 'פתיחת הדוח מהקובץ {name} שאושר {date}',
  'lab.recognition.rowAgain': 'זיהוי מחדש',
  'lab.recognition.rowAgainNamed': 'זיהוי מחדש של {name}',
  'lab.recognition.starting': 'הזיהוי מתחיל…',
  'lab.recognition.gone': 'הזיהוי הזה כבר אינו קיים. ייתכן שבוטל במקום אחר.',
  'lab.recognition.loadFailed':
    'לא ניתן לקרוא את הזיהוי. יש לחזור לרשימת הקבצים ולפתוח אותו שוב.',
  'lab.recognition.replaceTitle': 'לזהות את המסמך מחדש?',
  'lab.recognition.replaceDetail':
    'כאשר הזיהוי החדש יאושר, התוצאות שזוהו מהמסמך הזה יוסרו מהתיק. מספר התוצאות: {count}, דוח מתאריך {date}.',
  'lab.recognition.replaceKept':
    'עד אז הן נשארות בתיק, וביטול הזיהוי החדש לא ישנה אותן. המסמך יזוהה מההתחלה.',
  'lab.recognition.replaceKeep': 'להשאיר את התוצאות הנוכחיות',
  'lab.recognition.analysingDetail':
    'קוראים את העמודים ומאתרים את אלה שיש בהם תוצאות מעבדה. לאחר מכן בוחרים את העמודים לזיהוי.',
  'lab.recognition.recognizingDetail': 'מזהים את העמודים שנבחרו.',
  'lab.recognition.progress': 'עמודים שזוהו: {done} מתוך {total}',
  'lab.recognition.keepsWorking':
    'אפשר לעזוב את העמוד. הזיהוי ממשיך, ושורת הקובץ תראה מתי נדרשת פעולה.',
  'lab.recognition.pagesTitle': 'בחירת העמודים לזיהוי',
  'lab.recognition.pagesDetail':
    'העמודים שנראים כתוצאות מעבדה מסומנים. רק העמודים המסומנים מזוהים: בטלו את הסימון של עמוד שאינו תוצאות וסמנו עמוד שהוחמץ.',
  'lab.recognition.page': 'עמוד {number}',
  'lab.recognition.enlargePage': 'הגדלת עמוד {number}',
  'lab.recognition.pageImage': 'עמוד {number} של המסמך',
  'lab.recognition.pageImageUnavailable': 'התצוגה אינה זמינה',
  'lab.recognition.markLaboratory': 'תוצאות מעבדה',
  'lab.recognition.markOther': 'תוכן אחר',
  'lab.recognition.markNoText': 'לא נמצא טקסט',
  'lab.recognition.chosenCount': 'עמודים שנבחרו: {count}',
  'lab.recognition.recognizeChosen': 'זיהוי העמודים שנבחרו',
  'lab.recognition.addPages': 'הוספת עמודים',
  'lab.recognition.addPagesTitle': 'הוספת עמודים לטיוטה',
  'lab.recognition.addPagesDetail':
    'העמודים שכבר זוהו נשארים בטיוטה, וגם העריכות השמורות נשמרות. יש לבחור אילו עמודים לזהות בנוסף.',
  'lab.recognition.recognizeAdded': 'זיהוי העמודים שנוספו',
  'lab.recognition.backToDraft': 'חזרה לטיוטה',
  'lab.recognition.sending': 'שולח…',
  'lab.recognition.cannotRun': 'זיהוי עמודים דורש הרשאה להפעלת פונקציות בינה מלאכותית.',
  'lab.recognition.pagesFailed': 'לא ניתן לשלוח את בחירת העמודים. יש לנסות שוב.',
  'lab.recognition.failedTitle': 'הזיהוי נעצר.',
  'lab.recognition.retry': 'לנסות שוב',
  'lab.recognition.retrying': 'מתחיל מחדש…',
  'lab.recognition.retryFailed': 'לא ניתן להפעיל את הזיהוי מחדש. יש לנסות שוב.',
  'lab.recognition.cancel': 'ביטול הזיהוי',
  'lab.recognition.cancelQuestion':
    'לבטל את הזיהוי הזה? מה שנקרא עד כה יימחק. תוצאות שאושרו נשארות כפי שהן.',
  'lab.recognition.cancelKeep': 'להמשיך בזיהוי',
  'lab.recognition.cancelConfirm': 'ביטול הזיהוי',
  'lab.recognition.cancelling': 'מבטל…',
  'lab.recognition.cancelFailed': 'לא ניתן לבטל את הזיהוי. יש לנסות שוב.',
  'lab.recognition.cancelChanged': 'מצב הזיהוי השתנה. יש לטעון אותו מחדש לפני הביטול.',
  'lab.recognition.cancelReload': 'טעינת מצב הזיהוי מחדש',
  'lab.recognition.cancelReloadFailed': 'לא ניתן לטעון את מצב הזיהוי. יש לנסות לטעון אותו מחדש.',
  'lab.recognition.cancelReloaded': 'מצב הזיהוי העדכני מוצג. יש לאשר שוב את הביטול אם ברצונך למחוק אותו.',
  'lab.recognition.stageConflict':
    'הזיהוי השתנה במקום אחר. יש לחזור לרשימת הקבצים ולפתוח אותו שוב.',
  'lab.recognition.failureDisabled':
    'זיהוי בדיקות מעבדה כבוי במרפאה זו. מנהל יכול להפעיל אותו בהגדרות הבינה המלאכותית.',
  'lab.recognition.failureGoogle':
    'Google Document AI אינו מוגדר במרפאה זו. מנהל יכול להוסיף אותו בהגדרות הבינה המלאכותית.',
  'lab.recognition.failureTooLarge': 'המסמך גדול מדי או שיש בו יותר מדי עמודים לזיהוי.',
  'lab.recognition.failureUnreadable': 'לא ניתן לקרוא את עמודי המסמך. יש לבדוק שהקובץ נפתח.',
  'lab.recognition.failureUnavailable': 'הקובץ המקורי אינו זמין עוד.',
  'lab.recognition.failureQuota': 'האחסון של המרפאה מלא, ולכן לא ניתן היה לשמור את העמודים.',
  'lab.recognition.failureService': 'שירות הזיהוי לא ענה. יש לנסות שוב מאוחר יותר.',
  'lab.recognition.failureAnswer': 'לא ניתן היה להשתמש בתשובת הזיהוי. יש לנסות שוב.',
  'lab.recognition.failureUnknown': 'הזיהוי נתקל בשגיאה בלתי צפויה. יש לנסות שוב ולדווח למנהל אם היא חוזרת.',
}
